<div>
  <h1>The page you are looking for could not be found.</h1>
  <a [routerLink]="['/dashboard']">Go back to the dashboard</a>
</div>
